<section
  id="commitments"
  data-trust-finale
  class="border-y border-emerald-100 bg-emerald-50/60"
>
  <!-- <h2 class="sr-only">{{ content.title }}</h2>
  <div class="mx-auto grid max-w-7xl grid-cols-2 gap-3 px-4 py-5 lg:grid-cols-4 lg:gap-4">
    <article *ngFor="let item of content.items" data-commitment-seal class="flex min-w-0 flex-col items-start gap-3 rounded-xl border border-emerald-100 bg-white p-3 md:flex-row md:p-4">
      <span class="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-emerald-50 text-emerald-700">
        <mat-icon [svgIcon]="'hero:' + item.icon"></mat-icon>
      </span>
      <div class="min-w-0">
        <h3 class="text-sm font-semibold text-slate-900">{{ item.title }}</h3>
        <p class="mt-1 text-xs leading-relaxed text-slate-600">{{ item.description }}</p>
      </div>
    </article>
  </div> -->
</section>
